import { Link } from 'react-router-dom';
import Button from '../../components/ui/Button';
import { Card, CardHeader, CardTitle, CardContent } from '../../components/ui/Card';

/**
 * Legacy route: password reset is completed from the email link (Supabase recovery → /auth/callback).
 */
export default function ResetPasswordPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950 px-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Reset password</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-sm text-gray-600 dark:text-gray-300">
          <p>
            Use the link in your password-reset email. It opens a secure page where you can choose a new password.
          </p>
          <p>
            <Link to="/forgot-password" className="text-blue-600 dark:text-blue-400 font-medium">
              Request a new reset link
            </Link>
          </p>
          <Link to="/login">
            <Button className="w-full">Back to sign in</Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
